import { Button, Divider, Icon, Modal, Table, Tooltip } from "antd";
import moment from "moment";
import React, { Component } from "react";

import axios from "axios";
import AddPartnerModal from "./AddPartnerModal";
// import AddPartnerLocationModal from './AddPartnerLocationModal';

const { Column } = Table;
const { confirm } = Modal;

class AllPartners extends Component {
  state = {
    info: [],
    visible: false,
    loading: true,
    confirmLoading: false,
    addLocationModal: false,
  };

  componentDidMount = () => {
    // const { id } = this.props.match.params;
    axios({
      method: "get",
      url: "/partners.json",
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    })
      .then((response) => {
        // console.log(response.data);
        this.setState({
          info: response.data,
          loading: false,
        });
        // console.log(JSON.stringify(this.state.info));
      })
      .catch((error) => {
        alert(`${error}: ${error.code}`);
      });
  };

  showPartnerDashboard = (id) => {
    const { info } = this.state;
    const { history } = this.props;

    const selectedPartner = info.filter((inf) => inf.id === id);
    // console.log(this.state..state.data);
    history.push({
      pathname: `/managePartners/${id}`,
      state: { data: selectedPartner },
    });
  };

  handlePartnerClick = (id) => {
    const { info } = this.state;
    const { history } = this.props;

    const selectedPartner = info.filter((inf) => inf.id === id);
    history.push({
      pathname: `/Partners/${id}`,
      state: { data: selectedPartner },
    });
  };

  showDeleteConfirm = (id) => {
    const { info } = this.state;
    confirm({
      title: "Are you sure delete this Partner?",
      content: "This cannot be undone.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: () => {
        axios({
          method: "delete",
          url: `/partners/${id}.json`,
          headers: { Authorization: sessionStorage.getItem("jwtToken") },
        }).then(() => {
          const newInfo = info.filter((inf) => inf.id !== id);
          this.setState({ info: newInfo });
          // console.log(response.status);
        });
      },
      onCancel: () => console.log("Cancel"),
    });
  };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  };

  addPartner = () => {
    this.setState({ visible: true });
  };

  handleCancel = () => {
    this.setState({ visible: false });
  };

  handleCreate = () => {
    const { info } = this.state;
    const { form } = this.formRef.props;

    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      values.start_date = moment(values.start_date).format("YYYY-MM-DD");
      this.setState({ confirmLoading: true });
      const CreatePartnerObj = this.constructObject(values);
      let partnerID;
      let partnerLocationObj;
      axios({
        method: "post",
        url: "/partners.json",
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
        data: CreatePartnerObj,
      })
        .then((response) => {
          this.setState({
            info: info.concat(response.data),
            confirmLoading: false,
          });
          partnerID = response.data.id;
          // console.log(partnerID, '2');
          partnerLocationObj = this.constructPartnerLocationObject(
            partnerID,
            values
          );
          form.resetFields();
          this.setState({ visible: false });
          window.location.reload();
        })
        .then(() => {
          axios({
            method: "post",
            url: "/partner_locations.json",
            headers: { Authorization: sessionStorage.getItem("jwtToken") },
            data: partnerLocationObj,
          }).then(() => ({
            confirmLoading: false,
          }));
          form.resetFields();
          this.setState({ visible: false });
          // window.location.reload();
        });
    });
  };

  constructPartnerLocationObject = (id, val) => ({
    partner_location: {
      name: val.line_1,
      partner_id: id,
      address: {
        address_name: val.address_name,
        line_1: val.line_1,
        line_2: null,
        city: val.city,
        state: val.state,
        pin_code: val.pin_code,
        country: val.country,
      },
      partner_contacts: [
        {
          name: val.contact_name,
          email: val.email,
          mobile_number: val.phone,
        },
      ],
    },
  });

  constructObject = (val) => ({
    partner: {
      name: val.name,
      partner_type: val.partner_type,
      start_date: val.start_date,
      payment_cycle: val.payment_cycle,
      payment_schedule_day: val.payment_schedule_day,
      address: {
        address_name: val.address_name,
        line_1: val.line_1,
        line_2: null,
        city: val.city,
        state: val.state,
        pin_code: val.pin_code,
        country: val.country,
      },
      partner_contacts: [
        {
          name: val.contact_name,
          email: val.email,
          mobile_number: val.phone,
        },
      ],
    },
  });

  render() {
    const { loading, info, visible, confirmLoading } = this.state;

    return (
      <div style={{ width: "90%", margin: "auto", marginTop: "5%" }}>
        <h2 className="display-4 text-center">Our Partners</h2>
        <hr width="200px" />

        <Table
          loading={loading}
          pagination={false}
          align="right"
          dataSource={info || null}
        >
          <Column title="ID" dataIndex="id" key="id" />

          <Column title="Name" dataIndex="name" key="name" />

          <Column title="Type" dataIndex="partner_type" key="partner_type" />

          <Column
            title="Active Patients"
            dataIndex="active_patients"
            key="active_patients"
          />

          <Column
            title="Contact"
            dataIndex="partner_contacts"
            render={(contacts) => `${contacts[0].name}`}
            key="contacts"
          />

          <Column
            title="#Locations"
            dataIndex="num_partner_locations"
            key="num_partner_locations"
          />

          <Column
            title="Actions"
            key="id"
            render={(record) => (
              <span>
                <Tooltip placement="top" title="View">
                  <span
                    onClick={() => this.showPartnerDashboard(record.id)}
                    role="button"
                  >
                    <a>
                      <Icon type="file-text" />
                    </a>
                  </span>
                </Tooltip>

                <Divider type="vertical" />

                <Tooltip placement="top" title="Edit">
                  <span
                    onClick={() => this.handlePartnerClick(record.id)}
                    role="button"
                  >
                    <a>
                      <Icon type="edit" />
                    </a>
                  </span>
                </Tooltip>

                {/* <Divider type="vertical" />

                                    <Tooltip placement="top" title="Add a location">
                                        <span >
                                            <a onClick={() => this.showAddLocationModal(record.id)} ><Icon type="plus"/></a>
                                            <AddPartnerLocationModal
                                                visible={this.state.addLocationModal === record.id}
                                                wrappedComponentRef={this.saveFormRefAddLocation}
                                                onCancel={this.handleCancelLocationModal}
                                                onCreate={this.handleCreateAddLocationModal}
                                            />
                                        </span>
                                    </Tooltip> */}

                <Divider type="vertical" />

                <Tooltip placement="top" title="Delete">
                  <span
                    onClick={() => this.showDeleteConfirm(record.id)}
                    role="button"
                  >
                    <a>
                      <Icon type="close-circle" style={{ color: "red" }} />
                    </a>
                  </span>
                </Tooltip>
              </span>
            )}
          />
        </Table>
        <div>
          <Button
            className="float-right mt-2"
            type="primary"
            onClick={this.addPartner}
          >
            Add Partner
          </Button>

          <AddPartnerModal
            wrappedComponentRef={this.saveFormRef}
            visible={visible}
            onCancel={this.handleCancel}
            onCreate={this.handleCreate}
            confirmLoading={confirmLoading}
          />
        </div>
      </div>
    );
  }
}

export default AllPartners;



// WEBPACK FOOTER //
// ./src/component/Partners/AllPartners.js